import { resetStateBuilder } from './helperReducers';
import { createSlice } from '@reduxjs/toolkit';
import { fetchResumoCart, fetchResumoCartPerf } from '../api';
const initialState = {
    isLoaded: false,
    isLoadedPercent: false,
    loading: false,
    obj_datas: {
        data_ini: '',
        data_fim: '',
        data_ini2: '',
        datas_nao_uteis: '',
        data_mais_antiga_portfolio_AAAAmmDD: '',
        data_mais_recente_portfolio_AAAAmmDD: '',
    },
    resumo: {
        datas: {
            data_ini: '',
            data_fim: '',
        },
        saldoIni: '',
        saldoFim: '',
        impostospagos: '',
        rendimentoBruto: '',
        movimentacoes: '',
    },
    retorno: [],
    rendPorClasse: [],
    movimentacoes: [],
    alocClasse: [],
    alocCustodiante: [],
    selectedBenchmarks: null,
    tabela_liquidez: [],
    loadingPercent: false,
    isPercentToggle: false
};
export const resumoCartSlice = createSlice({
    name: 'resumoCart',
    initialState,
    reducers: {
        setSelectedBenchmarks: (state, action) => {
            // se estiver carregado com os benchmarks null, foram utilizados os benchmarks do CV_bench_carteira1
            if (state.isLoaded && state.selectedBenchmarks !== null) {
                state.selectedBenchmarks = action.payload;
                if (state.selectedBenchmarks === action.payload) {
                    state.isLoaded = false;
                }
            }
            else { // se já estiver carregado com os benchs da preferencia, não recarregar
                state.selectedBenchmarks = action.payload;
            }
        },
        resetSelectedBenchmarks: (state) => {
            state.selectedBenchmarks = initialState.selectedBenchmarks;
        },
        setIsPercentToggle: (state, action) => {
            state.isPercentToggle = action.payload;
        },
    },
    extraReducers: (builder) => {
        resetStateBuilder(builder, initialState, ['selectedBenchmarks']);
        builder.addCase(fetchResumoCart.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchResumoCart.fulfilled, (state, action) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            state.loading = false;
            state.isLoaded = true;
            state.obj_datas = (_a = action.payload.ResumoCart) === null || _a === void 0 ? void 0 : _a.obj_datas;
            state.retorno = (_b = action.payload.ResumoCart) === null || _b === void 0 ? void 0 : _b.retorno;
            state.rendPorClasse = (_c = action.payload.ResumoCart) === null || _c === void 0 ? void 0 : _c.rendPorClasse;
            state.movimentacoes = (_d = action.payload.ResumoCart) === null || _d === void 0 ? void 0 : _d.movimentacoes;
            state.resumo = (_e = action.payload.ResumoCart) === null || _e === void 0 ? void 0 : _e.resumo;
            state.alocCustodiante = (_f = action.payload.ResumoCart) === null || _f === void 0 ? void 0 : _f.alocCustodiante;
            state.alocClasse = (_g = action.payload.ResumoCart) === null || _g === void 0 ? void 0 : _g.alocClasse;
            state.tabela_liquidez = (_h = action.payload.ResumoCart) === null || _h === void 0 ? void 0 : _h.tabela_liquidez;
        });
        builder.addCase(fetchResumoCart.rejected, (state) => {
            state.loading = false;
        });
        builder.addCase(fetchResumoCartPerf.pending, (state) => {
            state.loadingPercent = true;
        });
        builder.addCase(fetchResumoCartPerf.fulfilled, (state, action) => {
            var _a;
            state.isLoadedPercent = true;
            state.loadingPercent = false;
            state.dadosPercentResumo = (_a = action.payload.ResumoCartPerf) === null || _a === void 0 ? void 0 : _a.perfPorClasse;
        });
        builder.addCase(fetchResumoCartPerf.rejected, (state) => {
            state.loadingPercent = false;
        });
    },
});
export const { setSelectedBenchmarks, resetSelectedBenchmarks, setIsPercentToggle } = resumoCartSlice.actions;
// export const selectToken = (state: RootState) => state.preference.token;
export default resumoCartSlice.reducer;
